import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header w-full flex flex-shrink-0 border-b border-gray-200 rounded-t-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-md ml-2 text-black mt-1" }, "Cerrar", -1)
const _hoisted_3 = {
  key: 0,
  id: "messages",
  class: "flex flex-col w-full space-y-1 p-2 overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch",
  style: {"max-height":"76%"}
}
const _hoisted_4 = ["item", "onClick"]
const _hoisted_5 = { class: "flex items-start col-span-7" }
const _hoisted_6 = { class: "w-full flex flex-col space-y-2 max-w-xs mx-2 order-2 items-start" }
const _hoisted_7 = { class: "w-full px-4 py-2 rounded-lg inline-block text-black" }
const _hoisted_8 = { class: "text-md font-bold" }
const _hoisted_9 = { class: "text-md" }
const _hoisted_10 = { class: "flex text-right" }
const _hoisted_11 = {
  key: 1,
  class: "py-40 text-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "m-auto" }, "No hay registros disponibles", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_fa = _resolveComponent("fa")!
  const _component_sirit_right_menu = _resolveComponent("sirit-right-menu")!
  const _component_comment_modal = _resolveComponent("comment-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_sirit_right_menu, { size: "md" }, {
      rightMenuContent: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal())),
            class: "cursor-pointer font-bold text-xl hover:text-sirit_blue-400"
          }, "x"),
          _hoisted_2
        ]),
        (!_ctx.loading && _ctx.comments.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([[item.commentsCountUnread > 0 ? 'bg-sirit_blue-50 text-sirit_blue-500' : 'bg-white'], "border-b chat-message h-20 grid grid-cols-8 cursor-pointer hover:text-sirit_blue-100 px-2"]),
                  key: item.id,
                  item: item,
                  onClick: () => $setup.setDebtorCaseId(item.debtorCaseId, item.clientReference, item.participantName)
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_fa, {
                      icon: "envelope",
                      class: "m-auto"
                    }),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("h3", _hoisted_8, "Fra " + _toDisplayString(item.clientReference), 1),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.participantName), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_fa, {
                      icon: "angle-right",
                      class: "m-auto text-black"
                    })
                  ])
                ], 10, _hoisted_4))
              }), 128))
            ]))
          : (!_ctx.loading && _ctx.comments.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.openModalComment)
      ? (_openBlock(), _createBlock(_component_comment_modal, {
          key: 0,
          onOnFire: $setup.eventOpenModal_comment,
          openModal: _ctx.openModalComment,
          item: _ctx.item
        }, null, 8, ["onOnFire", "openModal", "item"]))
      : _createCommentVNode("", true)
  ], 64))
}